"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRedirectIfAuth = void 0;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var react_router_1 = require("react-router");
var single_1 = require("utils/selectors/single");
var useRedirectIfAuth = function (chekForCompanyId) {
    var authState = (0, react_redux_1.useSelector)(single_1.selectAuth);
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var history = (0, react_router_1.useHistory)();
    react_1.default.useEffect(function () {
        if (!(0, react_redux_firebase_1.isEmpty)(authState) && !(0, react_redux_firebase_1.isEmpty)(profile) && (!chekForCompanyId || profile.companyId)) {
            history.push('/');
        }
    }, [authState, profile]);
};
exports.useRedirectIfAuth = useRedirectIfAuth;
